import { Router } from '@angular/router';
import { AppConfig } from './config.app';
import '../../extension-methods/observable.extension';
import '../../extension-methods/router.extension';

export function FactoryAppConfig(appConfig: AppConfig, router: Router): () => Promise<unknown> {
  console.log('Config Service Factory loaded');
  // Promise wrapped in promise to make provision for async calls in setup after loadConfig
  const promise = new Promise((res) => {
    appConfig.loadConfig().then(() => {
      console.info('%c Environment:', 'color:rgb(246, 255, 0)', appConfig.environment);
      console.info('%c Logging level:', 'color:rgba(255, 149, 0, 1)', appConfig.logging.loggingLevel);
      console.info('%c Logging to:', 'color:rgba(255, 149, 0, 1)', appConfig.logging.errorLogTo.join(', '));
      router.InitializeExtensionMethods();
      res(true);
    });
  });
  // For the app initializer the factory needs to return a function that returns a promise
  return () => promise;
}
